/*
 *  Single-office Google map with one marker.
 *
 *  Reads everything from the container's data attributes, so any template can
 *  drop in a container and get the same map:
 *
 *  <div class="map" id="map-container"
 *      data-marker-image="..." data-title="..." data-address="..."
 *      data-gps-lat="50.031505" data-gps-lng="14.520601" data-map-url="...">
 *
 *  Waits for the Google Maps API, which global-header.html flips on through
 *  mapApiInitCallback(); the template still has to load the API script itself.
 */
function OfficeMap(containerObject){
	/* THIS FIX */
	var _this = this;

	/* PRIVATE CONSTANTS */
	var MAP_INIT_RETRY_MAX = 10;
	var MARKER_SIZE = { width: 44, height: 60 };
	// AdvancedMarkerElement only renders on a map that has a Map ID. DEMO_MAP_ID is
	// Google's own testing id, as used in the migration guide - swap it for a Map ID
	// from the Cloud Console (Maps > Map Management) before going live.
	var MAP_ID = 'DEMO_MAP_ID';

	/* PRIVATE VARIABLES */
	var mapInitRetryCount = 0;
	var markerImageUrl = null;


	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;


	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}


	function mapInitCallback(){
		mapInitRetryCount ++;
		if (mapApiInited) {
			initMap();
		} else {
			if (mapInitRetryCount < MAP_INIT_RETRY_MAX) {
				setTimeout(mapInitCallback, 1000);
			}
		}
	}


	function initMap(){
		var title = _this.container.data('title');
		var address = _this.container.data('address');
		var gpsLat = parseFloat(_this.container.data('gpsLat'));
		var gpsLng = parseFloat(_this.container.data('gpsLng'));
		var mapUrl = _this.container.data('mapUrl') || '';

		// An office without an address resource has no coordinates - leave the
		// container empty rather than dropping a marker in the ocean.
		if (isNaN(gpsLat) || isNaN(gpsLng)) {
			return;
		}

		var pos = { lat: gpsLat, lng: gpsLng };
		var map = new google.maps.Map(_this.container.get(0), {
			center: pos,
			zoom: 16,
			mapId: MAP_ID,
			scrollwheel: false,
			// touch devices: require two fingers, so one-finger scrolling still
			// scrolls the page instead of being swallowed by the map
			gestureHandling: 'cooperative'
		});

		var contentString = '<div class="map-info-window-content">';
		contentString += '<h3>' + title + '</h3>';
		contentString += '<p>' + address + '</p>';
		if(mapUrl.length > 7) {
			contentString += '<p><a href="' + mapUrl + '" target="_blank">Zvětšit mapu</a></p>';
		}
		contentString += '</div>';

		var infowindow = new google.maps.InfoWindow({
			content: contentString
		});

		var pin = document.createElement('img');
		pin.src = markerImageUrl;
		pin.width = MARKER_SIZE.width;
		pin.height = MARKER_SIZE.height;

		var marker = new google.maps.marker.AdvancedMarkerElement({
			map: map,
			position: pos,
			title: title,
			content: pin,
			gmpClickable: true
		});

		// advanced markers fire gmp-click, not click
		marker.addListener('gmp-click', function () {
			infowindow.open({ anchor: marker, map: map });
		});

		// The column the map sits in can be laid out after the map initialises;
		// re-centre on breakpoint changes so the marker never drifts off-canvas.
		Gridle.on('update', function(){
			google.maps.event.trigger(map, 'resize');
			map.setCenter(pos);
		});
	}


	/* PUBLIC FUNCTIONS */
	this.init = function(){
		if(!_this.inited && _this.container.length === 1){

			// object references
			markerImageUrl = _this.container.data('markerImage');

			// init
			mapInitCallback();

			_this.inited = true;
		}
	};


	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
